<template>
  <div class="quote-request-container">
    <s-toolbar
      label="Solicitud de Cotización"
      save
      @save="save()"
      @close="$emit('close')"
      close
    ></s-toolbar>
    
    <v-card flat class="pa-4">
      <v-container fluid>
        <!-- Sección de Configuración -->
        <v-card outlined class="config-card mb-4" elevation="2">
          <v-card-title class="gradient-header white--text py-3">
            <v-icon left color="white">mdi-cog-outline</v-icon>
            <span class="text-h6">Configuración de Cotización</span>
          </v-card-title>
          
          <v-card-text class="pa-4">
            <v-row dense>
              <!-- Moneda -->
              <v-col cols="12" sm="6" md="3">
                <div class="input-group">
                  <label class="input-label">
                    <v-icon small color="primary" class="mr-1">mdi-currency-usd</v-icon>
                    Moneda
                  </label>
                  <s-select-definition 
                    :def="1129" 
                    v-model="TypeCurrency"
                    outlined
                    dense
                    hide-details
                  ></s-select-definition>
                </div>
              </v-col>
              
              <!-- Fecha Límite -->
              <v-col cols="12" sm="6" md="3">
                <div class="input-group">
                  <label class="input-label">
                    <v-icon small color="primary" class="mr-1">mdi-calendar</v-icon>
                    Fecha Límite
                  </label>
                  <s-date 
                    v-model="QuoteDate"
                    outlined
                    dense
                    hide-details
                  ></s-date>
                </div>
              </v-col>
              
              <!-- Hora Límite -->
              <v-col cols="12" sm="6" md="3">
                <div class="input-group">
                  <label class="input-label">
                    <v-icon small color="primary" class="mr-1">mdi-clock-outline</v-icon>
                    Hora Límite
                  </label>
                  <s-text 
                    v-model="QuoteTime"
                    type="time"
                    outlined
                    dense
                    hide-details
                    label="Hora Límite"
                  ></s-text>
                </div>
              </v-col>
            </v-row>
            
            <!-- Selector de Proveedores Mejorado -->
            <v-row dense class="mt-4">
              <v-col cols="12">
                <v-divider class="mb-4"></v-divider>
                <div class="input-group">
                  <label class="input-label">
                    <v-icon small color="primary" class="mr-1">mdi-account-multiple</v-icon>
                    Proveedores Seleccionados
                    <v-chip 
                      x-small 
                      :color="itemsSupplier.length > 0 ? 'success' : 'grey'" 
                      text-color="white"
                      class="ml-2"
                    >
                      {{ itemsSupplier.length }}
                    </v-chip>
                  </label>
                  
                  <!-- Chips de Proveedores Seleccionados -->
                  <div class="providers-chips-container mb-3" v-if="itemsSupplier.length > 0">
                    <v-chip
                      v-for="(supplier, index) in itemsSupplier"
                      :key="supplier.SupCode"
                      close
                      @click:close="removeSupplierByIndex(index)"
                      color="primary"
                      text-color="white"
                      class="ma-1 provider-chip"
                    >
                      <v-icon left small>mdi-account</v-icon>
                      {{ supplier.SupName }}
                    </v-chip>
                  </div>
                  
                  <div v-else class="empty-providers-state mb-3">
                    <v-icon color="grey lighten-1">mdi-information-outline</v-icon>
                    <span class="grey--text text--lighten-1 ml-2">
                      No hay proveedores seleccionados. Agregue al menos uno para continuar.
                    </span>
                  </div>
                  
                  <!-- Selector para Agregar Proveedor -->
                  <v-row dense align="center">
                    <v-col cols="12" sm="8">
                      <s-provider
                        return-object
                        v-model="supObject"
                        label="Buscar y agregar proveedor"
                        outlined
                        dense
                        hide-details
                        prepend-inner-icon="mdi-magnify"
                      ></s-provider>
                    </v-col>
                     <v-col cols="12" sm="2" class="text-center">
                         <v-btn
                            color="info"
                            @click="openAddSupplierDialog()"
                            block
                            depressed
                            outlined
                         >
                            <v-icon left>mdi-account-search</v-icon>
                            Buscar
                         </v-btn>
                     </v-col>
                    <v-col cols="12" sm="2" class="text-center">
                      <v-btn 
                        color="success" 
                        @click="addSupplier()"
                        :disabled="!supObject"
                        block
                        depressed
                      >
                        <v-icon left>mdi-plus</v-icon>
                        Agregar
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Sección de Items para Cotizar -->
        <v-card outlined class="items-card" elevation="2">
          <v-card-title class="gradient-header-items white--text py-3">
            <v-icon left color="white">mdi-package-variant</v-icon>
            <span class="text-h6">Items para Cotizar</span>
            <v-chip
              class="ml-3"
              small
              color="white"
              text-color="primary"
            >
              <v-icon left x-small>mdi-format-list-numbered</v-icon>
              {{ itemsLocal.length }} {{ itemsLocal.length === 1 ? 'item' : 'items' }}
            </v-chip>
          </v-card-title>
          
          <v-card-text class="pa-0">
            <v-data-table
              :items="itemsLocal"
              :headers="headersItems"
              dense
              hide-default-footer
              item-key="DerID"
              :items-per-page="-1"
              class="elevation-0 items-table"
            >
              <!-- Código con badge -->
              <template v-slot:item.ArtCode="{ item }">
                <v-chip 
                  x-small 
                  outlined 
                  :color="item.ArtCode ? 'primary' : 'grey'"
                  class="font-weight-medium"
                >
                  {{ item.ArtCode || 'N/A' }}
                </v-chip>
              </template>
              
              <!-- Cantidad Editable con mejor diseño -->
              <template v-slot:item.QdtQuantity="{ item }">
                <s-text
                  style="width: 90px"
                  decimal
                  v-model="item.QdtQuantity"
                  @blur="validateQuantity(item)"
                  :error="item.quantityError"
                  outlined
                  dense
                  hide-details
                  class="quantity-input"
                ></s-text>
              </template>
              
              <!-- Cantidad Requerida (Referencia) -->
              <template v-slot:item.DerQuantity="{ item }">
                <v-chip x-small color="blue-grey lighten-4" text-color="blue-grey darken-2">
                  <v-icon x-small left>mdi-information</v-icon>
                  {{ item.DerQuantity }}
                </v-chip>
              </template>
              
              <!-- Unidad de Medida -->
              <template v-slot:item.UnitMeasurement="{ item }">
                <span class="text-caption font-weight-medium">{{ item.UnitMeasurement }}</span>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-container>
    </v-card>
    
    <!-- Dialog para Agregar Proveedor Manual -->
    <v-dialog v-model="dialogAddSupplier" max-width="500px">
      <v-card>
        <v-card-title class="headline primary white--text">
          <v-icon left color="white">mdi-account-plus</v-icon>
          Agregar Proveedor Manual
        </v-card-title>
        
        <v-card-text class="pt-4">
          <v-row>
            <v-col cols="12">
              <span class="subtitle-2 grey--text text--darken-1">
                Ingrese el RUC del proveedor para buscarlo.
              </span>
            </v-col>
            <v-col cols="12">
              <s-text
                label="RUC"
                v-model="newSupplierRuc"
                number
                :maxlength="11"
                @keyupEnter="searchNewSupplier()"
                autofocus
                outlined
                dense
              >
                <template v-slot:append>
                  <v-btn
                    icon
                    small
                    color="primary"
                    @click="searchNewSupplier()"
                    :loading="isSearchingSupplier"
                  >
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </template>
              </s-text>
            </v-col>
            
            <v-col cols="12" v-if="foundSupplier">
              <v-alert
                border="left"
                colored-border
                :color="foundSupplier.Source === 'SYSTEM' ? 'info' : 'success'"
                elevation="2"
                :icon="foundSupplier.Source === 'SYSTEM' ? 'mdi-database' : 'mdi-web'"
              >
                <div class="subtitle-1 font-weight-bold">
                  {{ foundSupplier.SupName }}
                  <v-chip
                    x-small
                    class="ml-2"
                    :color="foundSupplier.Source === 'SYSTEM' ? 'blue' : 'green'"
                    text-color="white"
                  >
                    {{ foundSupplier.Source === 'SYSTEM' ? 'SISTEMA' : 'SUNAT' }}
                  </v-chip>
                </div>
                <div class="caption">{{ foundSupplier.SupCode }}</div>

                <!-- Detalles adicionales si es del sistema -->
                <div v-if="foundSupplier.Source === 'SYSTEM'" class="mt-2">
                  <v-divider class="my-1"></v-divider>
                  <div v-if="foundSupplier.UsrStatus === 'ACTIVE'">
                    <v-icon small color="success" left>mdi-check-circle-outline</v-icon>
                    <span class="text-caption success--text">Usuario registrado y activo.</span>
                  </div>
                  <div v-else-if="foundSupplier.UsrStatus === 'Invited' || foundSupplier.UsrStatus === 'INVITED'">
                     <div class="d-flex align-center mb-1">
                        <v-icon small color="warning" left>mdi-alert-circle-outline</v-icon>
                        <span class="text-caption warning--text font-weight-bold">Usuario registrado pero pendiente de validación.</span>
                     </div>
                     <div v-if="foundSupplier.UsrInviteToken" class="grey lighten-4 pa-2 rounded d-flex align-center justify-space-between">
                        <span class="text-caption grey--text text--darken-2">Token de invitación:</span>
                        <code class="text-caption font-weight-bold ml-2">{{ foundSupplier.UsrInviteToken }}</code>
                        <v-btn icon x-small @click="$fun.copy(foundSupplier.UsrInviteToken)">
                            <v-icon x-small>mdi-content-copy</v-icon>
                        </v-btn>
                     </div>
                  </div>
                </div>

                <!-- Detalles adicionales si es de SUNAT, permitir invitar -->
                <div v-if="foundSupplier.Source === 'SUNAT'" class="mt-3">
                   <v-divider class="mb-3"></v-divider>
                   
                   <div v-if="!foundSupplier.InvitationSent">
                       <span class="caption grey--text text--darken-1 d-block mb-2">
                           Este proveedor no está registrado. Ingrese un usuario para invitarlo:
                       </span>
                       <v-row dense align="center">
                           <v-col cols="8">
                               <s-text
                                   label="Usuario"
                                   v-model="foundSupplier.Username"
                                   dense
                                   outlined
                                   hide-details
                                   class="caption"
                               ></s-text>
                           </v-col>
                           <v-col cols="4">
                              <v-btn 
                                small 
                                color="primary" 
                                depressed 
                                block 
                                @click="createAndInviteSupplier()"
                                :loading="isInviting"
                              >
                                  Crear e Invitar
                              </v-btn>
                           </v-col>
                       </v-row>
                   </div>
                   
                   <div v-else>
                        <div class="d-flex align-center mb-1">
                            <v-icon small color="success" left>mdi-check-circle</v-icon>
                            <span class="text-caption success--text font-weight-bold">Usuario creado e invitado exitosamente.</span>
                        </div>
                        <div v-if="foundSupplier.UsrInviteToken" class="grey lighten-4 pa-2 rounded d-flex align-center justify-space-between">
                            <span class="text-caption grey--text text--darken-2">Token:</span>
                            <code class="text-caption font-weight-bold ml-2">{{ foundSupplier.UsrInviteToken }}</code>
                            <v-btn icon x-small @click="$fun.copy(foundSupplier.UsrInviteToken)">
                                <v-icon x-small>mdi-content-copy</v-icon>
                            </v-btn>
                        </div>
                        <div v-if="foundSupplier.InvitationLink" class="mt-1">
                             <a :href="foundSupplier.InvitationLink" target="_blank" class="text-caption">Link de activación</a>
                             <v-btn icon x-small color="primary" @click="$fun.copy(foundSupplier.InvitationLink)">
                                <v-icon x-small>mdi-content-copy</v-icon>
                            </v-btn>
                        </div>
                   </div>
                </div>

              </v-alert>
            </v-col>
             <v-col cols="12" v-else-if="!isSearchingSupplier && newSupplierRuc.length === 11 && !foundSupplier">
                <div class="text-caption grey--text text-center">
                   Presione Enter o la lupa para buscar
                </div>
            </v-col>
          </v-row>
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="dialogAddSupplier = false">Cancelar</v-btn>
          <v-btn
            color="success"
            @click="confirmAddSupplier()"
            :disabled="!foundSupplier || (foundSupplier.Source === 'SUNAT' && !foundSupplier.InvitationSent)"
            depressed
          >
            Agregar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _sLgsQuotation from "@/services/Logistics/LgsQuotationService.js";
import _sGenEmail from "@/services/General/GenEmailService.js";
import _sSunarp from "@/services/General/SearchSunarp.js";

export default {
  name: "QuoteRequest",
  components: {},
// ... (rest uses existing code but skipping unchanged parts for brevity if possible, 
// here I need to replace methods too so I will replace the template part above and then methods below separately or together if context allows. 
// Given the tool limitations, I should focus on the template part first then methods.)
// Wait, I can't split easily if I don't see exact line numbers. 
// I will just replace the template part first. Oops, wait, I need to replace the logic too.
// I will do the template replacement first.

  props: {
    items: {
      type: Array,
      default: () => []
    },
  },
  data: () => ({
    selectedSuppliers: [],
    supObject: null,
    quoteCurrency: null,
    QuoteDate: null,
    QuoteTime: null,
    headersSupplier: [
      { text: "Proveedor", value: "SupName", width: 400 },
    ],
    headersItems: [
      { text: "Código", value: "ArtCode", width: 100 },
      { text: "Descripción", value: "DerDescription", width: 400 },
      { text: "Cant. Req.", value: "DerQuantity", width: 100, align: 'center' },
      { text: "Cantidad", value: "QdtQuantity", width: 100, align: 'center' },
      { text: "UM", value: "UnitMeasurement", width: 80, align: 'center' },
      { text: "Centro Costo", value: "CceName", width: 250 },
      { text: "Línea Negocio", value: "BslName", width: 250 },
    ],
    itemsSupplier: [],
    itemsLocal: [],
    TypeCurrency: null,
    // Supplier Lookup Data
    dialogAddSupplier: false,
    newSupplierRuc: '',
    foundSupplier: null,
    isSearchingSupplier: false,
    isInviting: false,
  }),
  mounted() {
    this.initializeItems();
    this.initializeDefaults();
  },
  methods: {
    initializeDefaults() {
      // Inicializar fecha actual
      this.QuoteDate = this.$fun.getDate();
      this.QuoteTime = new Date().toTimeString().substr(0, 5);
      // Moneda por defecto (puedes ajustar según necesidad)
      this.quoteCurrency = null;
    },
    initializeItems() {
      // Inicializar items con cantidad editable
      this.itemsLocal = this.items.map(item => ({
        ...item,
        QdtQuantity: item.DerQuantity, // Inicializar con la cantidad del requerimiento
        quantityError: false
      }));
    },
    validateQuantity(item) {
      // Para servicios (sin código de artículo), no validar contra DerQuantity
      const isService = !item.ArtCode || item.ArtCode === '' || item.ArtCode === null;
      
      if (isService) {
        // Solo validar que la cantidad sea mayor a 0
        if (item.QdtQuantity <= 0 || item.QdtQuantity == null) {
          item.quantityError = true;
          this.$fun.alert('La cantidad debe ser mayor a 0', 'warning');
          item.QdtQuantity = 1; // Valor por defecto para servicios
        } else {
          item.quantityError = false;
        }
      } else {
        // Para artículos, validar que no exceda la cantidad requerida
        if (item.QdtQuantity > item.DerQuantity) {
          item.quantityError = true;
          this.$fun.alert(
            `La cantidad no puede exceder la cantidad requerida (${item.DerQuantity})`,
            'warning'
          );
          item.QdtQuantity = item.DerQuantity;
        } else if (item.QdtQuantity <= 0 || item.QdtQuantity == null) {
          item.quantityError = true;
          this.$fun.alert('La cantidad debe ser mayor a 0', 'warning');
          item.QdtQuantity = item.DerQuantity;
        } else {
          item.quantityError = false;
        }
      }
    },
    removeSupplier() {
      this.selectedSuppliers.forEach((element) => {
        this.itemsSupplier = this.itemsSupplier.filter(
          (x) => x.SupCode != element.SupCode
        );
      });
      this.selectedSuppliers = [];
    },
    removeSupplierByIndex(index) {
      this.itemsSupplier.splice(index, 1);
    },
    groupDetailsByArticle(items) {
      const services = items.filter(item => !item.ArtCode || item.ArtCode === '' || item.ArtCode === null);
      const articles = items.filter(item => item.ArtCode && item.ArtCode !== '' && item.ArtCode !== null);
      
      const groupedArticles = {};
      articles.forEach(item => {
        if (!groupedArticles[item.ArtCode]) {
          groupedArticles[item.ArtCode] = {
            ...item,
            QdtQuantity: item.QdtQuantity,
            DerQuantity: item.QdtQuantity,
            originalDetails: [item]
          };
        } else {
          groupedArticles[item.ArtCode].QdtQuantity += item.QdtQuantity;
          groupedArticles[item.ArtCode].DerQuantity += item.QdtQuantity;
          groupedArticles[item.ArtCode].originalDetails.push(item);
        }
      });
      
      const groupedArticlesArray = Object.values(groupedArticles).map(item => {
        const { originalDetails, ...rest } = item;
        return rest;
      });
      
      return [...groupedArticlesArray, ...services];
    },
    save() {
      if (this.itemsSupplier.length < 1) {
        this.$fun.alert("Seleccione al menos un Proveedor", "warning");
        return;
      }
      
      if (!this.QuoteDate || !this.QuoteTime) {
          this.$fun.alert("Debe ingresar Fecha y Hora Límite", "warning");
          return;
      }
      
      const hasInvalidQuantity = this.itemsLocal.some(item => {
        const isService = !item.ArtCode || item.ArtCode === '' || item.ArtCode === null;
        
        if (isService) {
          // Para servicios, solo validar que sea mayor a 0
          return item.QdtQuantity <= 0 || item.QdtQuantity == null;
        } else {
          // Para artículos, validar contra DerQuantity
          return item.QdtQuantity <= 0 || 
                 item.QdtQuantity > item.DerQuantity || 
                 item.QdtQuantity == null;
        }
      });

      if (hasInvalidQuantity) {
        this.$fun.alert("Verifique las cantidades de los items", "warning");
        return;
      }
      
      const QttDateLimit = `${this.QuoteDate}T${this.QuoteTime}`; // ISO format-ish or simplified
      console.log("QttDateLimit (Concatenated)", QttDateLimit);
      
      this.$fun
        .alert("¿Seguro de generar solicitudes de cotización?", "question")
        .then((r) => {
          if (r.value) {

            const itemsToSend = this.itemsLocal.map(item => ({
              ...item,
              DerQuantity: item.QdtQuantity,
              UsrCreateID: this.$fun.getUserID()
            }));

            const groupedItems = this.groupDetailsByArticle(itemsToSend);

            const suppliersToSend = this.itemsSupplier.map(s => ({
              SupCode: s.SupCode,
              SupName: s.SupName,
              UsrCreateID: this.$fun.getUserID(),
              Detail: itemsToSend,
              DetailGroup: groupedItems
            }));

            const quotationPayload = {
              TypeCurrency: this.TypeCurrency,
              QttDateLimit: QttDateLimit,
              UsrCreateID: this.$fun.getUserID(),
              Supplier: suppliersToSend
            };

            console.log("Enviando Payload Cotización:", quotationPayload);

            _sLgsQuotation.save(quotationPayload, this.$fun.getUserID())
              .then((res) => {
                 if (res.status === 200) {
                    this.$fun.alert("Se guardo correctamente", "success");
                    
                    // Enviar correos a proveedores
                    this.itemsSupplier.forEach(supplier => {
                        _sLgsQuotation.getEmailSupplier(supplier.SupCode, this.$fun.getUserID())
                            .then((resEmail) => {
                              console.log("resEmail", resEmail);
                                if (resEmail.status === 200 && resEmail.data && resEmail.data.length > 0) {
                                    const supplierEmail = "desarrollador.ti@sunshineperu.com" //resEmail.data[0].SupEmail; // Asumiendo que devuelve un array con SupEmail
                                    console.log("supplierEmail", supplierEmail);
                                    if (supplierEmail) {
                                        const emailBody = `
                                            <html>
                                                <body>
                                                    <p>Estimado Proveedor ${supplier.SupName},</p>
                                                    <p>Se le ha generado una solicitud de cotización con fecha límite ${this.$fun.formatDateView(this.QuoteDate)} ${this.QuoteTime}.</p>
                                                    <p>Por favor, ingrese al portal para visualizar los detalles y responder.</p>
                                                    <br>
                                                    <p>Atentamente,</p>
                                                    <p>SunExpert</p>
                                                </body>
                                            </html>
                                        `;
                                        
                                        const mailPayload = {
                                            emailTo: supplierEmail, 
                                            subject: "Solicitud de Cotización - SunExpert",
                                            bodyMail: emailBody,
                                        };
                                        
                                        _sGenEmail.sendEmail(mailPayload, this.$fun.getUserID())
                                            .then(resMail => {
                                                if(resMail.status === 200) {
                                                    console.log(`Correo enviado a ${supplier.SupName}`);
                                                }
                                            })
                                            .catch(errMail => {
                                                console.error(`Error enviando correo a ${supplier.SupName}`, errMail);
                                            });
                                    }
                                }
                            });
                    });

                    this.$emit("saved");
                 }
              })
              .catch((err) => {
                 console.error("Error al guardar cotización", err);
              });
          }
        });
    },
    validationFormSupplier() {
      if (this.supObject == null) {
        this.$fun.alert("Seleccione un Proveedor", "warning");
        return false;
      }
      if (
        this.itemsSupplier.filter((x) => x.SupCode == this.supObject.SupID)
          .length > 0
      ) {
        this.$fun.alert("El proveedor ya está en la lista", "warning");
        return false;
      }
      return true;
    },
    addSupplier() {
      if (this.validationFormSupplier()) {
        this.itemsSupplier.push({
          SupName: this.supObject.SupName,
          SupCode: this.supObject.SupID,
          UsrCreateID: this.$fun.getUserID(),
        });
        this.supObject = null; // Limpiar selector
      }
    },
    // Manual Supplier Lookup Methods
    openAddSupplierDialog() {
      this.dialogAddSupplier = true;
      this.newSupplierRuc = '';
      this.foundSupplier = null;
      this.isSearchingSupplier = false;
    },
    searchNewSupplier() {
      if (!this.newSupplierRuc || this.newSupplierRuc.length !== 11) {
        this.$fun.alert("Ingrese un RUC válido de 11 dígitos", "warning");
        return;
      }

      this.isSearchingSupplier = true;
      this.foundSupplier = null;

      // 1. Search in Local DB
      _sLgsQuotation.getUser(this.newSupplierRuc, this.$fun.getUserID())
        .then(res => {
          console.log("Respuesta getUser", res);
          if (res.status === 200 && res.data && res.data.UsrUsername) {
             // Found in Local DB
             console.log("Found Local Provider:", res.data); // Debugging
             this.foundSupplier = {
               SupName: res.data.ProviderName,
               SupCode: res.data.UsrUsername, // This is the RUC/ID
               Source: 'SYSTEM',
               UsrStatus: res.data.UsrStatus, // Assuming API returns UsrStatus
               UsrInviteToken: res.data.UsrInviteToken // Assuming API returns UsrInviteToken
             };
             this.isSearchingSupplier = false;
          } else {
             // 2. Not found in Local DB, search in SUNAT
             this.searchInSunat();
          }
        })
        .catch(() => {
           // Error or not found, try SUNAT
           this.searchInSunat();
        });
    },
    searchInSunat() {
      _sSunarp.Search(this.newSupplierRuc, this.$fun.getUserID())
        .then(resp => {
           this.isSearchingSupplier = false;
           if (resp.status === 200 && resp.data) {
             // Found in SUNAT
             this.foundSupplier = {
               SupName: resp.data.SunName,
               SupCode: this.newSupplierRuc, // Use the searched RUC
               Source: 'SUNAT',
               Username: `PN${this.newSupplierRuc}`, // Default Username
               InvitationSent: false
             };
           } else {
             this.$fun.alert("No se encontró información para el RUC ingresado", "warning");
           }
        })
        .catch(err => {
           this.isSearchingSupplier = false;
           console.error("Error searching SUNAT", err);
           this.$fun.alert("Error al buscar en SUNAT", "error");
        });
    },
    createAndInviteSupplier() {
        if (!this.foundSupplier.Username) {
            this.$fun.alert("Ingrese un nombre de usuario", "warning");
            return;
        }

        this.isInviting = true;

        const payload = {
            UsrUsername: this.foundSupplier.Username,
            UsrEmail: `${this.foundSupplier.Username}@gmail.com`,
            ProviderId: this.foundSupplier.Username,
            providerName: this.foundSupplier.SupName
        };

        _sLgsQuotation.inviteSupplier(payload, this.$fun.getUserID())
            .then(res => {
              console.log("inviteSupplier", res);
                this.isInviting = false;
                if (res.status === 200 && res.data) {
                    // Success, token received
                    this.$set(this.foundSupplier, 'InvitationSent', true);
                    this.$set(this.foundSupplier, 'UsrInviteToken', res.data.Token);
                    this.$set(this.foundSupplier, 'InvitationLink', res.data.Link);
                    this.$set(this.foundSupplier, 'Source', 'SYSTEM'); // Consider it system now? Or keep SUNAT but invited?
                    // Let's keep it visually distinct or update to SYSTEM-like but with create success
                    
                    this.$fun.alert("Usuario creado e invitado correctamente", "success");
                } else {
                  console.log("Error al crear usuario", res);
                }
            })
            .catch(err => {
                this.isInviting = false;
                console.error("Error inviting user", err);
            });
    },
    confirmAddSupplier() {
      if (this.foundSupplier) {
        // Check if already in list
        if (
            this.itemsSupplier.filter((x) => x.SupCode == this.foundSupplier.SupCode)
              .length > 0
          ) {
            this.$fun.alert("El proveedor ya está en la lista", "warning");
            return;
          }

        this.itemsSupplier.push({
          SupName: this.foundSupplier.SupName,
          SupCode: this.foundSupplier.SupCode,
          UsrCreateID: this.$fun.getUserID(),
        });
        
        this.dialogAddSupplier = false;
        this.foundSupplier = null;
        this.newSupplierRuc = '';
      }
    },
  },
};
</script>

<style scoped>
/* Container principal */
/* .quote-request-container {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  min-height: 100vh;
  padding: 20px;
} */

/* Cards principales */
.config-card,
.items-card {
  border-radius: 12px !important;
  overflow: hidden;
  transition: all 0.3s ease;
  background: white;
}

.config-card:hover,
.items-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
  transform: translateY(-2px);
}

/* Headers con gradiente */
.gradient-header {
  background: #4ba2a2 !important;
  border-radius: 0 !important;
}

.gradient-header-items {
  background: #575af5 !important;
  border-radius: 0 !important;
}

/* Input groups */
.input-group {
  margin-bottom: 8px;
}

.input-label {
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Chips de proveedores */
.providers-chips-container {
  background: #f8f9fa;
  border: 2px dashed #dee2e6;
  border-radius: 8px;
  padding: 12px;
  min-height: 60px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  transition: all 0.3s ease;
}

.providers-chips-container:hover {
  border-color: #667eea;
  background: #f0f4ff;
}

.provider-chip {
  font-weight: 500 !important;
  transition: all 0.2s ease;
  animation: chipFadeIn 0.3s ease;
}

.provider-chip:hover {
  transform: scale(1.05);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
}

@keyframes chipFadeIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Estado vacío de proveedores */
.empty-providers-state {
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}

/* Tabla de items */
.items-table {
  border-radius: 0 0 12px 12px !important;
}

.items-table >>> .v-data-table__wrapper {
  border-radius: 0 0 12px 12px;
}

.items-table >>> tbody tr:hover {
  background-color: #f8f9fa !important;
}

/* Input de cantidad */
.quantity-input {
  transition: all 0.2s ease;
}

.quantity-input:focus-within {
  transform: scale(1.05);
}

/* Mejoras generales */
.v-card {
  border-radius: 12px !important;
}

.v-card-title {
  font-size: 16px !important;
  font-weight: 600 !important;
}

.v-btn {
  text-transform: none !important;
  font-weight: 600 !important;
  letter-spacing: 0.5px !important;
}

/* Responsive */
@media (max-width: 960px) {
  .quote-request-container {
    padding: 10px;
  }
  
  .input-label {
    font-size: 12px;
  }
}

/* Animaciones suaves para transiciones */
* {
  transition: background-color 0.2s ease, color 0.2s ease;
}
</style>
